"use strict";

exports.__esModule = true;
exports.getField = getField;
exports.getList = getList;

var _fields = require("material-ui-shell/lib/providers/Filter/fields");

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function getField(name, fields) {
  if (fields === void 0) {
    fields = [];
  }

  var field = false;
  fields.map(function (f) {
    var _f$type = f.type,
        type = _f$type === void 0 ? 'text' : _f$type;

    if (f.name === name) {
      var defaultProps = {};

      if (type === 'number') {
        defaultProps = _extends({}, _fields.numberField);
      } else if (type === 'text') {
        defaultProps = _extends({}, _fields.textField);
      } else if (type === 'bool') {
        defaultProps = _extends({}, _fields.boolField);
      } else if (type === 'time') {
        defaultProps = _extends({}, _fields.timeField);
      } else if (type === 'date') {
        defaultProps = _extends({}, _fields.dateField);
      }

      field = _extends(_extends({}, defaultProps), f);
    }

    return f;
  });
  return field;
}

function getList(filter, list, fields) {
  if (filter === void 0) {
    filter = {};
  }

  if (list === void 0) {
    list = [];
  }

  if (fields === void 0) {
    fields = [];
  }

  var result = [].concat(list);
  var _filter = filter,
      _filter$queries = _filter.queries,
      queries = _filter$queries === void 0 ? [] : _filter$queries,
      sortFieldName = _filter.sortField,
      _filter$sortOrientati = _filter.sortOrientation,
      sortOrientation = _filter$sortOrientati === void 0 ? 1 : _filter$sortOrientati,
      _filter$search = _filter.search,
      search = _filter$search === void 0 ? {} : _filter$search;
  var _search$value = search.value,
      searchValue = _search$value === void 0 ? '' : _search$value;

  if (list == null || list.length < 1) {
    return [];
  }

  if (fields.length > 0) {
    result = result.filter(function (row) {
      var show = true;

      for (var i = 0; i < queries.length; i++) {
        var q = queries[i];
        var fieldName = q.field;
        var field = getField(fieldName, fields);

        if (field) {
          show = field.filter(row[fieldName], q);
        }

        if (!show) {
          return show;
        }
      }

      return show;
    });
  }

  if (searchValue != null && searchValue !== '' && searchValue !== undefined) {
    result = result.filter(function (row) {
      if (row === void 0) {
        row = {};
      }

      return JSON.stringify(_extends({}, row)).toUpperCase().indexOf(String(searchValue).toUpperCase()) !== -1;
    });
  }

  if (sortFieldName && sortFieldName !== '') {
    var sortField = getField(sortFieldName, fields);

    if (result !== undefined && sortField.sort !== undefined) {
      result.sort(function (a, b) {
        return sortField.sort(sortOrientation, a[sortFieldName], b[sortFieldName]);
      });
    }
  }

  return result;
}